import { createContext } from "react";

export interface DirtyStateContextType {
  isDirty: boolean;
  setDirty: (dirty: boolean) => void;
  confirmNavigation: () => boolean;
}

export const DirtyStateContext = createContext<DirtyStateContextType | undefined>(undefined);
